import * as yup from 'yup';

const filterSchema = yup.object().shape({
  to: yup.date().required('End Date is required'),
  from: yup.date().required('Start Date is required'),
});

export default filterSchema;
